import angular from "angular";
import { configureStates } from "../../core/router/router-helper.provider";

const routes = [{
    state: "rogersDashboard",
    config: {
        url: "/rogers-dashboard",
        abstract: true,
        data: {
            permissionKey: "navigation:rogersDashboard"
        }
    }
},
{
    state: "rogersDashboard.slippageReport",
    config: {
        url: "/slippage-report",
        component: "apexRogersSlippageReportContainer",
        data: {
            pageHeader: "Rogers Slippage report",
            permissionKey: "navigation:rogersSlippageReport"
        }
    }
},
{
    state: "rogersDashboard.recruitingBonusReport",
    config: {
        url: "/recruiting-bonus-report",
        component: "apexRogersRecruitingBonusReportContainer",
        data: {
            pageHeader: "Rogers Recruiting Bonus report",
            permissionKey: "navigation:rogersRecruitingBonusReport"
        }
    }
}];

export const RogersDashboardingRoutingModule = angular
    .module("apex.mainApp.rogersDashboard.routing", [])
    .run(configureStates(routes))
    .name;
